const createState = () => ({
  filter: {
    query: {},
    formData: {},
    isActive: false
  }
})

const createGetters = () => ({
  getFilterFormData: state => state.filter.formData,
  isActiveFilter: state => state.filter.isActive
})

const createMutations = () => ({
  SET_FILTER_QUERY: (state, filter) => {
    state.filter.query = filter
  },

  SET_FILTER_FORM_DATA: (state, data) => {
    state.filter.formData = data
  },

  OPEN_FILTER: state => {
    state.filter.isActive = true
  },

  CLOSE_FILTER: state => {
    state.filter.isActive = false
  },

  TOGGLE_FILTER_IS_ACTIVE: state => {
    state.filter.isActive = !state.filter.isActive
  },

  RESET_FILTER_QUERY: state => {
    state.filter.query = {}
  },

  RESET_FILTER_FORM_DATA: state => {
    state.filter.formData = {}
  }
})

const createActions = () => ({
  async loadFilter ({ commit, dispatch }, filter = {}) {
    commit('SET_CURRENT_PAGE', 1)
    commit('SET_FILTER_QUERY', filter)
    await dispatch('loadList')
  }
})

const vuexFilterBase = {
  createState,
  createGetters,
  createMutations,
  createActions
}

export {
  vuexFilterBase
}
